import { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import CsplLabel from "./CsplControls/CsplLabel/CsplLabel";

const OtpModal = ({
  show,
  onClose,
  onSubmit,
  onResendOtp,
  onGetAadharDetails,
  messageText,
  messageType,
  isButtonDisable,
  setIsButtonDisable,
}) => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);
  const isOtpComplete = otp.every((digit) => digit !== "");
  const [resendTimer, setResendTimer] = useState(90);

  useEffect(() => {
    let interval = null;

    if (show) {
      interval = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [show]);

  useEffect(() => {
    if (resendTimer === 0) return;

    const interval = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [resendTimer]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (otp[index]) {
        newOtp[index] = "";
      } else if (index > 0) {
        newOtp[index - 1] = "";
        inputRefs.current[index - 1]?.focus();
      }
      setOtp(newOtp);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const otpString = otp.join("");
    onSubmit(otpString); // Pass OTP to parent handler
  };

  const handleResend = (e) => {
    e.preventDefault();
    if (resendTimer === 0 && onResendOtp) {
      onResendOtp();
      setResendTimer(90);
    }
  };

  const handleGetAadharDetails = (e) => {
    e.preventDefault();
    if (onGetAadharDetails) {
      onGetAadharDetails();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop={false}
      className="modal_OtpGuide modal_OtpMainbody"
      backdropClassName="transparent-backdrop"
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.2)" }}
    >
      <Modal.Body>
        {messageText && (
          <div
            style={{
              backgroundColor:
                messageType === "success" ? "#d4edda" : "#f8d7da",
              border: `1px solid ${messageType === "success" ? "#c3e6cb" : "#f5c6cb"}`,
              color: messageType === "success" ? "#155724" : "#721c24",
              borderRadius: "5px",
              padding: "10px",
              textAlign: "center",
              marginBottom: "15px",
            }}
          >
            {messageText}
          </div>
        )}
        <p className="text-center mb-3">Enter your OTP here</p>
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          {otp.map((digit, index) => (
            <div
              key={index}
              style={{
                position: "relative",
                width: "32px",
                textAlign: "center",
              }}
            >
              <div
                onClick={() => inputRefs.current[index]?.focus()}
                style={{
                  fontSize: "22px",
                  minHeight: "30px",
                  color: "#000",
                  cursor: "text",
                  userSelect: "none",
                }}
              >
                {digit ? "•" : ""}
              </div>
              <input
                type="text"
                maxLength="1"
                inputMode="numeric"
                value={digit}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                ref={(el) => (inputRefs.current[index] = el)}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "transparent",
                  border: "none",
                  outline: "none",
                  color: "transparent", // hides number
                  // textShadow: "0 0 0 #000",    // shows black cursor
                  caretColor: "#000", // black blinking cursor
                  fontSize: "22px", // ensure cursor aligns with dot
                  cursor: "text",
                  //opacity: 0
                }}
              />
              <div
                style={{
                  height: "2px",
                  backgroundColor: "#6f6d6d",
                  marginTop: "4px",
                }}
                onClick={() => inputRefs.current[index]?.focus()}
              />
            </div>
          ))}
        </div>
        <div className="mt-3">
          <div style={{ marginRight: "10px", textAlign: "right" }}>
            {resendTimer > 0 ? (
              <span style={{ color: "#aaa", marginRight: "10px" }}>
                Resend OTP in {resendTimer}s
              </span>
            ) : (
              <a
                href="#"
                style={{ marginRight: "10px" }}
                onClick={handleResend}
              >
                Resend
              </a>
            )}
          </div>
          <div className="mt-3 text-center">
            <CsplLabel label="mainAppLayout.otpHelpText"></CsplLabel>
          </div>
          <div className="mt-3 text-center">
            <a href="#" onClick={handleGetAadharDetails}>
              Switch to Aadhaar Journey
            </a>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={!isOtpComplete || isButtonDisable}
          className={`btn-otp ${isOtpComplete ? "btn-otp-enabled" : "btn-otp-disabled"}`}
        >
          Verify
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OtpModal;
